import { motion } from "framer-motion";
import styles from "./TattooLightbox.module.css";

const TattooLightbox = ({ image, onClose }) => {
  return (
    <motion.div
      className={styles.overlay}
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <motion.button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.2,
          delay: 0.15,
          ease: "easeOut",
        }}
        aria-label="Close image preview"
      >
        ×
      </motion.button>

      <motion.div
        className={styles.imageShell}
        onClick={(event) => event.stopPropagation()}
      >
        <motion.img
          layoutId={`tattoo-image-${image.id}`}
          src={image.src}
          alt={image.alt}
          className={styles.image}
          transition={{
            layout: {
              duration: 0.55,
              ease: [0.16, 1, 0.3, 1],
            },
          }}
        />
      </motion.div>
    </motion.div>
  );
};

export default TattooLightbox;